import React,{useEffect,useRef} from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import Card from './search-card.js'
import Header from './search-header.js'
import useApp from './use-app-context.js'
import getSearchResults from '../functions/get-search-results.js'

const Search = () => {
  const ref = useRef()
  const app = useApp()

  const search = app.search
  const text = search.text
  const setResults = search.setResults
  const results = search.results
  const isActive = search.isActive

  useEffect(() => {
    if (!text) return

    const timeout = setTimeout(() => {
      getSearchResults({text,setResults})
    },500)

    return () => clearTimeout(timeout)
  },[text,isActive])

  const cards = results.map(page => {
    const props = {page}

    return <Card {...props}/>
  })

  const onClick = event => {
    if (event.target === event.currentTarget) {
      
    }
  }

  const props = {isActive,onClick}

  if (!isActive) return

  return (
    <Container {...props}>
      <Wrap>
        <Content>
          <Header {...props}/>
          <Results>
            {cards}
          </Results>
        </Content>
      </Wrap>
    </Container>
  )
}

const Container = styled.div`
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  // display: ${props => props.isActive ? 'block' : 'none'};
  cursor: pointer;
`

const Wrap = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: ${theme.section.width.small};
  max-width: 100%;
  z-index: 10000;
  cursor: initial;
`

const Content = styled.div`
  margin: ${theme.pad.small};
  background: ${theme.color.grey.lightest};
  padding-top: 6rem;
`

const Results = styled.div`
  padding: ${theme.padding.small};
  height: 65rem;
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: scroll;
  width: 100%;
`

export default Search